export const vatZeroPer1Data = [
    {
        "id": "1",
        "code": "1",
        "description": "Χωρίς ΦΠΑ - άρθρο 2 και 3 του Κώδικα ΦΠΑ (ν. 5144/2024)"
    },
    {
        "id": "2",
        "code": "2",
        "description": "Χωρίς ΦΠΑ - άρθρο 5 του Κώδικα ΦΠΑ (ν. 5144/2024)"
    },
    {
        "id": "3",
        "code": "3",
        "description": "Χωρίς ΦΠΑ - άρθρο 17 του Κώδικα ΦΠΑ (ν. 5144/2024)"
    },
    {
        "id": "4",
        "code": "4",
        "description": "Χωρίς ΦΠΑ - άρθρο 18 του Κώδικα ΦΠΑ (ν. 5144/2024)"
    },
    {
        "id": "5",
        "code": "5",
        "description": "Χωρίς ΦΠΑ - άρθρο 21 του Κώδικα ΦΠΑ (ν. 5144/2024)"
    },
    {
        "id": "6",
        "code": "6",
        "description": "Χωρίς ΦΠΑ - άρθρο 24 του Κώδικα ΦΠΑ (ν. 5144/2024)"
    },
    {
        "id": "7",
        "code": "7",
        "description": "Χωρίς ΦΠΑ - άρθρο 27 του Κώδικα ΦΠΑ (ν. 5144/2024)"
    },
    {
        "id": "8",
        "code": "8",
        "description": "Χωρίς ΦΠΑ - άρθρο 29 του Κώδικα ΦΠΑ (ν. 5144/2024)"
    },
    {
        "id": "9",
        "code": "9",
        "description": "Χωρίς ΦΠΑ - άρθρο 30 του Κώδικα ΦΠΑ (ν. 5144/2024)"
    },
    {
        "id": "10",
        "code": "10",
        "description": "Χωρίς ΦΠΑ - άρθρο 31 του Κώδικα ΦΠΑ (ν. 5144/2024)"
    },
    {
        "id": "11",
        "code": "11",
        "description": "Χωρίς ΦΠΑ - άρθρο 32 του Κώδικα ΦΠΑ (ν. 5144/2024)"
    },
    {
        "id": "12",
        "code": "12",
        "description": "Χωρίς ΦΠΑ - άρθρο 32 του Κώδικα ΦΠΑ - Πλοία Ανοικτής Θαλάσσης του Κώδικα ΦΠΑ (ν. 5144/2024)"
    }
]

export const vatZeroPer2Data = [
    {
        "id": "13",
        "code": "13",
        "description": "Χωρίς ΦΠΑ - άρθρο 32 .1.γ. του Κώδικα ΦΠΑ - Πλοία Ανοικτής Θαλάσσης του Κώδικα ΦΠΑ (ν. 5144/2024)"
    },
    {
        "id": "14",
        "code": "14",
        "description": "Χωρίς ΦΠΑ - άρθρο 33 του Κώδικα ΦΠΑ (ν. 5144/2024)"
    },
    {
        "id": "15",
        "code": "15",
        "description": "Χωρίς ΦΠΑ - άρθρο 44 του Κώδικα ΦΠΑ (ν. 5144/2024)"
    },
    {
        "id": "16",
        "code": "16",
        "description": "Χωρίς ΦΠΑ - άρθρο 45 του Κώδικα ΦΠΑ (ν. 5144/2024)"
    },
    {
        "id": "17",
        "code": "17",
        "description": "Χωρίς ΦΠΑ - άρθρο 47 του Κώδικα ΦΠΑ (ν. 5144/2024)"
    },
    {
        "id": "18",
        "code": "18",
        "description": "Χωρίς ΦΠΑ - άρθρο 48 του Κώδικα ΦΠΑ (ν. 5144/2024)"
    },
    {
        "id": "19",
        "code": "19",
        "description": "Χωρίς ΦΠΑ - άρθρο 54 του Κώδικα ΦΠΑ (ν. 5144/2024)"
    },
    {
        "id": "20",
        "code": "20",
        "description": "ΦΠΑ εμπεριεχόμενος - άρθρο 50 του Κώδικα ΦΠΑ (ν. 5144/2024)"
    },
    {
        "id": "21",
        "code": "21",
        "description": "ΦΠΑ εμπεριεχόμενος - άρθρο 51 του Κώδικα ΦΠΑ (ν. 5144/2024)"
    },
    {
        "id": "22",
        "code": "22",
        "description": "ΦΠΑ εμπεριεχόμενος - άρθρο 52 του Κώδικα ΦΠΑ (ν. 5144/2024)"
    },
    {
        "id": "23",
        "code": "23",
        "description": "ΦΠΑ εμπεριεχόμενος - άρθρο 53 του Κώδικα ΦΠΑ (ν. 5144/2024)"
    },
    {
        "id": "24",
        "code": "24",
        "description": "Χωρίς ΦΠΑ - άρθρο 8 του Κώδικα ΦΠΑ (ν. 5144/2024)"
    },
    {
        "id": "25",
        "code": "25",
        "description": "Χωρίς ΦΠΑ - ΠΟΛ.1029/1995 (ν. 5144/2024)"
    },
    {
        "id": "26",
        "code": "26",
        "description": "Χωρίς ΦΠΑ - ΠΟΛ.1167/2015 (ν. 5144/2024)"
    },
    {
        "id": "27",
        "code": "27",
        "description": "Λοιπές Εξαιρέσεις ΦΠΑ (ν. 5144/2024)"
    },
    {
        "id": "28",
        "code": "28",
        "description": "Χωρίς ΦΠΑ – άρθρο 29 περ. β’ παρ.1 του Κώδικα ΦΠΑ, (Tax Free) (ν. 5144/2024)"
    },
    {
        "id": "29",
        "code": "29",
        "description": "Χωρίς ΦΠΑ – άρθρο 56 του Κώδικα ΦΠΑ (OSS_μη ενωσιακό καθεστώς) (ν. 5144/2024)"
    },
    {
        "id": "30",
        "code": "30",
        "description": "Χωρίς ΦΠΑ – άρθρο 57 του Κώδικα ΦΠΑ (OSS_ενωσιακό καθεστώς) (ν. 5144/2024)"
    },
    {
        "id": "31",
        "code": "31",
        "description": "Χωρίς ΦΠΑ – άρθρο 58 του Κώδικα ΦΠΑ (IOSS) (ν. 5144/2024)"
    }
]

export const vatZeroPerData = [...vatZeroPer1Data, ...vatZeroPer2Data];